export default __webpack_public_path__ + "static/media/Нэгдсэн сургалт БЕГ хүүхэд хамгаалал.89665a58.pdf";